import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class CompletedECService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	createCompletedEC(data: any): Observable<any> {
		return this.http.post(`${this.uri}/completed-ec`, data);
	}

	// Set (not toggle) the completed status of one emergency contact
	setCompletedEC(id: string, completed: boolean): Observable<any> {
		return this.http.put(`${this.uri}/completed-ec/${id}`, { completed });
	}

	deleteCompletedEC(id: string): Observable<any> {
		return this.http.delete(`${this.uri}/completed-ec/${id}`);
	}
}
